import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '../views/layout/Layout.vue'
Vue.use(Router)

// export default new Router({
const routes = [{
    path: '/login',
    name: 'login',

    component: () => import('../views/login.vue'),
  },
  {
    path: '/brandchose',
    name: 'brandchose',
    component: () => import('../views/brandchose.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue'),
  },
  {
    path: '/Softwarexieyi',
    name: 'Softwarexieyi',
    component: () => import('../views/Softwarexieyi.vue'),
  },
  {
    path: '/404',
    name: '404',
    meta: {
      name: '404',
      hide: true,
      title: '404错误'
    },
    component: Layout,
    children: [{
      path: '/404',
      name: '404',
      meta: {
        name: '404',
        hide: true,
        title: '404错误'
      },
      component: () => import('../views/404.vue')
    }]

  },
  {
    path: '/',
    name: 'homepage',
    meta: {
      name: 'homepage',
      hide: false,
      title: '首页',
    },
    component: Layout,
    children: [{
      path: '/',
      name: 'homepage',
      meta: {
        name: 'homepage',
        hide: false,
        title: '首页'
      },
      component: () => import('../views/index.vue'),
    }]
  },
  {
    path: '/brand',
    name: 'brand',
    meta: {
      name: 'brand',
      hide: false,
      title: '品牌管理',
    },
    component: Layout,
    children: [{
      name: 'brand',
      path: '/brand',
      meta: {
        name: 'brand',
        hide: true,
        title: '品牌管理',
      },
      component: () => import('../views/brand.vue'),
    }, {
      name: 'brandParameter',
      path: '/brand/parameter',
      meta: {
        name: 'brand',
        hide: false,
        title: '品牌库',
      },
      component: () => import('../views/brandParameter.vue'),
    }, {
      name: 'brandBusiness',
      path: '/brand/business',
      meta: {
        name: 'brand',
        hide: false,
        title: '商机管理',
      },
      component: () => import('../views/brandBusiness.vue'),
    }, {
      name: 'brandIndustry',
      path: '/brand/industry',
      meta: {
        name: 'brand',
        hide: false,
        title: '行业商机',
      },
      component: () => import('../views/brandIndustry.vue'),
    }, {
      name: 'brandtweet',
      path: '/brand/brandtweet',
      meta: {
        name: 'brand',
        hide: true,
        title: '特推商机'
      },
      component: () => import('../views/brandtweet.vue'),
    }, {
      name: 'brandAdd',
      path: '/brand/addbrand',
      meta: {
        name: 'brand',
        hide: true,
        title: '添加品牌'
      },
      component: () => import('../views/addbrand.vue'),
    }, {
      name: 'brandedit',
      path: '/brand/edit/:id',
      meta: {
        name: 'brand',
        hide: true,
        title: '编辑品牌'
      },
      component: () => import('../views/addbrand.vue'),
    }, ]
  },
  {
    path: '/newsmanage',
    name: 'newsmanage',
    meta: {
      name: 'newsmanage',
      hide: false,
      title: '新闻管理',
    },
    component: Layout,
    children: [{
      name: 'newsmanage',
      path: '/newsmanage',
      meta: {
        name: 'newsmanage',
        hide: false,
        title: '新闻管理'
      },
      component: () => import('../views/newsmanage.vue'),
    }, {
      name: 'newsAdd',
      path: '/newsmanage/addnews',
      meta: {
        name: 'newsmanage',
        hide: true,
        title: '添加新闻'
      },
      component: () => import('../views/addnews.vue'),
    }, {
      name: 'newsedit',
      path: '/newsmanage/edit/:id',
      meta: {
        name: 'newsmanage',
        hide: true,
        title: '编辑新闻'
      },
      component: () => import('../views/addnews.vue'),
    }, ]
  },

  {
    path: '/staffmanage',
    name: 'staffmanage',
    meta: {
      name: 'staffmanage',
      hide: false,
      title: '员工管理',
    },
    component: Layout,
    children: [{
      name: 'staffmanage',
      path: '/staffmanage',
      meta: {
        name: 'staffmanage',
        hide: false,
        title: '员工管理'
      },
      component: () => import('../views/staffmanage.vue'),
    }]
  },
  {
    path: '/datuminfo',
    name: 'datuminfo',
    meta: {
      name: 'datuminfo',
      hide: false,
      title: '企业信息',
    },
    component: Layout,
    children: [{
      name: 'datuminfo',
      path: '/datuminfo',
      meta: {
        name: 'conlog',
        hide: false,
        title: '企业信息'
      },
      component: () => import('../views/datuminfo.vue'),
    }]
  },
  {
    path: '/conlog',
    name: 'conlog',
    meta: {
      name: 'conlog',
      hide: false,
      title: '操作日志',
    },
    component: Layout,
    children: [{
      name: 'conlog',
      path: '/conlog',
      meta: {
        name: 'conlog',
        hide: false,
        title: '操作日志'
      },
      component: () => import('../views/conlog.vue'),
    }]
  },


]
// })
const router = new Router({
  routes
})
// jimmy
router.beforeEach((to, from, next) => {
  if (to.query.auth) { //模拟登录
    localStorage.setItem("token", to.query.auth);
    localStorage.setItem("mobile", to.query.mobile);
    next('/');
  }
  if (to.matched.length === 0) {
    from.name ? next({
      name: from.name
    }) : next('/404');
  } else if(to.meta.hide && !to.name === '404'){
    next('/404');
  } else {
    next(); //如果匹配到正确跳转
  }
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js